var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerPinHighPower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 49,
    viewBox: "0 0 35 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_1943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.39 34.545C26.5358 34.545 33.95 27.1309 33.95 17.985C33.95 8.83921 26.5358 1.42505 17.39 1.42505C8.24415 1.42505 0.829987 8.83921 0.829987 17.985C0.829987 27.1309 8.24415 34.545 17.39 34.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 0.475101C12.8504 0.477752 8.40182 2.32267 5.1221 5.60427C1.84237 8.88587 -7.57478e-07 13.3355 0 17.9751C0 27.6351 17.49 48.5251 17.49 48.5251C17.49 48.5251 35 27.6351 35 17.9751C35 15.6761 34.547 13.3997 33.6669 11.2758C32.7869 9.15198 31.4969 7.22235 29.8708 5.5972C28.2447 3.97204 26.3144 2.68321 24.19 1.80434C22.0657 0.925468 19.789 0.473787 17.49 0.475101ZM17.49 32.6451C14.5857 32.6471 11.7461 31.7875 9.33047 30.1752C6.91482 28.5629 5.0317 26.2703 3.91937 23.5875C2.80703 20.9047 2.51548 17.9522 3.08159 15.1036C3.6477 12.2551 5.04604 9.63841 7.09968 7.58478C9.15331 5.53114 11.77 4.1328 14.6185 3.56669C17.4671 3.00058 20.4196 3.29213 23.1024 4.40447C25.7852 5.5168 28.0778 7.39992 29.6901 9.81557C31.3024 12.2312 32.162 15.0708 32.16 17.9751C32.16 19.9016 31.7805 21.8092 31.0433 23.5891C30.3061 25.3689 29.2255 26.9861 27.8633 28.3484C26.501 29.7106 24.8838 30.7912 23.104 31.5284C21.3241 32.2656 19.4165 32.6451 17.49 32.6451Z",
    fill: "#429538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.64 9.88501L17.61 15.755L23.28 15.765L17.5 26.065H15.11L17.22 19.745L12.32 19.755L15.5 9.88501H19.64Z",
    fill: "#429538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_1943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.99,
    height: 48.05,
    fill: "white",
    transform: "translate(0 0.475098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerPinHighPower);
export default __webpack_public_path__ + "static/media/charger-pin-high-power.d7720909844f3ddbbdb8e71332fd4277.svg";
export { ForwardRef as ReactComponent };